const fileNames = {
	fulfillmentOrder: 'Fulfillment Orders',
	product: 'Products',
	shipmentInfo: 'Fulfillment Shipments',
	shipmentInfoReturn: 'Return Shipments',
	pickingBatch: 'Batches',
	marketplaceOrder: 'Marketplace Orders',
	receivingManual: 'Manual Containers',
	receivingAutomated: 'Automated Containers',
};

export { fileNames };
